// extracted by mini-css-extract-plugin
export var cartContainer = "_p1-4";
export var gray = "_p1-1";
export var itemContainer = "_p1-2";
export var itemDetails = "_p1-3";
export var strong = "_p1-0";